import React, { FunctionComponent, ReactElement } from "react";
import { useIntl } from "react-intl";
import classNames from "classnames";

import "./Beltline.scss";

export interface BeltlineProps {
    children: ReactElement<BeltineItemProps>[];
    className?: string;
}

/**
 * A heavily-styled family of flex components for displaying a wrapping row of related data fields and/or actions in a "beltline"
 * @param props
 */
export const Beltline: FunctionComponent<BeltlineProps> = ({ children, className }) => {
    return <div className={classNames("beltline-container", className)}>{children}</div>;
};

export interface BeltineItemProps {
    label: {};
    content: {};
    labelClass?: string;
    contentClass?: string;
    className?: string;
}
export const BeltlineItem: FunctionComponent<BeltineItemProps> = ({
    label,
    labelClass,
    content,
    contentClass,
    className,
}) => {
    return (
        <div className={classNames("beltline-detail", className)}>
            <span className={classNames("beltline-detail-label", labelClass)}>{label}</span>
            <span className={classNames("beltline-detail-content", contentClass)}>{content}</span>
        </div>
    );
};

export interface BeltlineItemQuantityProps {
    label: {};
    quantity: number | string | boolean | ReactElement<any>;
    quantityTotal?: number | string | boolean | ReactElement<any>;
    labelClass?: string;
    contentClass?: string;
    className?: string;
}
export const BeltlineQuantity: FunctionComponent<BeltlineItemQuantityProps> = ({
    label,
    labelClass,
    quantity,
    quantityTotal,
    contentClass,
    className,
}) => {
    const intl = useIntl();
    const content = quantityTotal ? (
        intl.formatMessage(
            { id: "common.unit.fraction" },
            {
                part: <span className="beltline-quantity-part">{quantity}</span>,
                total: <span className="beltline-quantity-total">{quantityTotal}</span>,
            }
        )
    ) : (
        <span className="beltline-quantity-total">{quantity}</span>
    );
    return (
        <BeltlineItem
            className={classNames("beltline-quantity", className)}
            label={label}
            labelClass={labelClass}
            content={content}
            contentClass={contentClass}
        />
    );
};

export default Beltline;
